import { render, staticRenderFns } from "./Anker.vue?vue&type=template&id=ba7dc2c8&functional=true"
import script from "./Anker.vue?vue&type=script&lang=js"
export * from "./Anker.vue?vue&type=script&lang=js"
import style0 from "./Anker.vue?vue&type=style&index=0&id=ba7dc2c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports